import * as Styles from './styles'

const Star = ({ index, onSelect, isSelected, handleHoverRating }) => {
  return (
    <label>
      <input type="radio" onClick={() => onSelect(index + 1)} />
      <Styles.Star
        weight={isSelected ? 'fill' : 'thin'}
        size={40}
        onMouseEnter={() => handleHoverRating(index + 1)}
        onMouseLeave={() => handleHoverRating(null)}
        selected={isSelected}
        data-testid="star"
      />
    </label>
  )
}

export default Star
